export default __webpack_public_path__ + "static/media/NeutralAxisShiftImg.9b22e1a3.png";